var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectiveTowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3273fa",
    d: "M3.452 3.137l1.156.513.627.277 1.265.561 1.266-.56.627-.279 1.155-.512L6.5 0zm1.424 1.351l1.62 2.551 1.618-2.55-.009-.015-1.61.719-1.61-.719zm1.624 3.8L3.737 3.965 1.62 3.026 0 3.971l1.854 2.085L6.5 11.278l4.646-5.222L13 3.97l-1.619-.945-2.118.94zM1.398 20h10.204L9.95 18.418H3.052zm1.99-2.31h6.234l1.404-10.323-4.52 5.076-4.522-5.076z"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/post-match/objective-towers.svg";
export { SvgObjectiveTowers as ReactComponent };